// extracted by mini-css-extract-plugin
module.exports = {"categories-link":"locations_categories-link__UKs_C","categories-card":"locations_categories-card__1NQ8c","categories-back":"locations_categories-back__o_WUZ"};